import { useContext } from "react";
import { AnalyticsSetter, ShellContext } from "../context";

/**
 * Provides a method for setting the current amplitude analytics id
 * @returns the analytics setter function
 */
export function useAnalytics(): AnalyticsSetter {
  const { setAnalyticsId } = useContext(ShellContext);

  return setAnalyticsId;
}
